import { Pipe, PipeTransform } from '@angular/core';
import { PGUtilities } from '../utilities/pg-utilities';

@Pipe({
    name: 'stripHTML',
    standalone: false
})
export class StripHTMLPipe implements PipeTransform {

    public transform(value:string): string {
        if(value == null) return value;
        return PGUtilities.stripHTML(value);
    }
}
